import { render, staticRenderFns } from "./ChartKey.vue?vue&type=template&id=155b4126&"
import script from "./ChartKey.vue?vue&type=script&lang=js&"
export * from "./ChartKey.vue?vue&type=script&lang=js&"
import style0 from "./ChartKey.vue?vue&type=style&index=0&id=155b4126&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports